import { useQuery } from "@tanstack/react-query";
import { useUser } from "@clerk/clerk-react";
import { useApi } from "./useApi";
import { UserData } from "../types/user";
import { useTeamContext } from "../contexts/TeamContext";

export function useUserData() {
  const { user } = useUser();
  const { teamId } = useTeamContext();
  const api = useApi();

  const fetchUserData = async (): Promise<UserData> => {
    const params = new URLSearchParams();
    if (teamId) {
      params.append("team", teamId);
    }

    const { data } = await api.get<UserData>(
      `/v2/users/me?${params.toString()}`,
    );

    return {
      uid: data.uid,
      slack_user: data.slack_user,
      installations: data.installations,
      played_channels: data.played_channels,
      played_teammates: data.played_teammates,
      is_braid: data.is_braid,
    };
  };

  return useQuery({
    queryKey: ["userData", user?.id, teamId],
    queryFn: fetchUserData,
    enabled: !!user,
  });
}
